import { render, staticRenderFns } from "./GChatMessageMenu.vue?vue&type=template&id=590de934&scoped=true&"
import script from "./GChatMessageMenu.vue?vue&type=script&lang=ts&"
export * from "./GChatMessageMenu.vue?vue&type=script&lang=ts&"
import style0 from "./GChatMessageMenu.vue?vue&type=style&index=0&id=590de934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590de934",
  null
  
)

export default component.exports